import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import DropArrow from 'material-ui/svg-icons/navigation/arrow-drop-down';
import * as Colors from 'material-ui/styles/colors';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import Menu from 'material-ui/Menu';

const SECOND_BUTTON_SIZE = 36;
const VERTICAL_DIVIDER_WIDTH = 1;
const WIDTH = 180;

export default class SplitButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  onIconClick = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({
      open: true,
      anchorE1: ReactDOM.findDOMNode(this.splitButton),
    });
  };

  getContainerWidth() {
    return this.props.width || WIDTH;
  }

  getFirstButtonStyle() {
    return {
      width: this.getContainerWidth() - this.getSecondButtonWidth() - this.getVerticalDividerWidth(),
    };
  }

  getSecondButtonWidth() {
    return this.props.secondButtonWidth || SECOND_BUTTON_SIZE;
  }

  getSecondButtonStyle() {
    return {
      minWidth: this.getSecondButtonWidth(),
      display: 'inline-block',
    };
  }

  getVerticalDividerWidth() {
    return this.props.verticalDividerWidth || VERTICAL_DIVIDER_WIDTH;
  }

  getVerticalDividerStyle() {
    return {
      display: 'inline-block',
      height: this.getSecondButtonWidth(),
      width: this.getVerticalDividerWidth(),
      backgroundColor: Colors.grey300,
      verticalAlign: 'bottom',
    };
  }

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const {
      label,
      icon,
      onFirstButtonClick,
      firstButtonStyle,
      secondButtonStyle,
      children,
      menuItems,
      disabled,
      verticalDividerStyle,
      style,
      id,
      ...other
    } = this.props;
    return (
      <div style={{display: 'flex', alignItems: 'center', ...style}} {...other}>
        <Paper
          id={id}
          ref={ref => {
            if (ref) {
              this.splitButton = ref;
            }
          }}
        >
          <FlatButton
            className="cla-first-button"
            disabled={disabled}
            label={label}
            onClick={onFirstButtonClick}
            style={{...this.getFirstButtonStyle(), ...firstButtonStyle}}
          >
            {children}
          </FlatButton>
          <div style={{...this.getVerticalDividerStyle(), ...verticalDividerStyle}} />
          <FlatButton
            className="cla-second-button"
            disabled={disabled}
            onClick={this.onIconClick}
            icon={icon ? icon : <DropArrow />}
            style={{...this.getSecondButtonStyle(), secondButtonStyle}}
          />
          <Popover
            open={this.state.open}
            anchorEl={this.state.anchorE1}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}
            onRequestClose={this.handleRequestClose}
            animation={PopoverAnimationVertical}
            style={{marginTop: 10}}
          >
            <Menu onItemClick={this.handleRequestClose}>{menuItems}</Menu>
          </Popover>
        </Paper>
      </div>
    );
  }
}

SplitButton.propTypes = {
  width: PropTypes.number,
  secondButtonWidth: PropTypes.number,
  verticalDividerWidth: PropTypes.number,
  label: PropTypes.string,
  icon: PropTypes.element,
  onFirstButtonClick: PropTypes.func,
  firstButtonStyle: PropTypes.object,
  secondButtonStyle: PropTypes.object,
  verticalDividerStyle: PropTypes.object,
  menuItems: PropTypes.arrayOf(PropTypes.element),
};
